import { Modal } from 'react-bootstrap';
import { OptimizationFailureDetails } from '@Components/OptimizationFailureDetails/OptimizationFailureDetails';
import { OptimizationRun } from './PostOptimization/post-optimization-constants';

interface OptimizationLogsModalProps {
  run: OptimizationRun;
  company: string;
  streamingType: string;
  onHide: () => void;
}

export const OptimizationLogsModal = ({
  run,
  company,
  streamingType,
  onHide
}: OptimizationLogsModalProps) => {
  const links = run.log_url.includes('bpm-output')
    ? [
        {
          label: 'Optimizer Iterations',
          href: `https://us-west-2.console.aws.amazon.com/cloudwatch/home?region=us-west-2#logEventViewer:group=/aws/batch/job;filter=%22OPTIMIZER-ITERATION-${run.company_id}-${streamingType}-${run.build_number}%22;start=${run.start};end=${run.end}`
        }
      ]
    : [{ label: 'External Logs', href: run.log_url }];

  return (
    <Modal show onHide={onHide} size='lg' centered>
      <Modal.Header closeButton>
        <Modal.Title>Details for Run #{run.build_number}</Modal.Title>
      </Modal.Header>
      <Modal.Body className='optimization-log-links'>
        <OptimizationFailureDetails
          target={{
            type: 'streaming',
            company,
            streamingType,
            kpi: run.company_id,
            runId: run.build_number,
            status: run.status
          }}
        />
        {links.map(link => (
          <a key={link.label} href={link.href} target='_blank' rel='noopener noreferrer'>
            {link.label}
          </a>
        ))}
      </Modal.Body>
    </Modal>
  );
};
